import { STORE_NAME } from './store'
import { ITilsynsobjekt } from './types'
import { getProdusentNummerFromProdusent } from './helpers'
import { ROOT_STORE_NAME } from '../../store'
import { IStoreState } from '../../../../reducers/types'

export const tilsynsobjektSelectors = {
  getData:
    (id: string | undefined) =>
    (state: IStoreState): ITilsynsobjekt | undefined =>
      id ? state[ROOT_STORE_NAME][STORE_NAME].data[id]?.data : undefined,

  getLoadingStatus: (id: string | undefined) => (state: IStoreState) =>
    id ? state[ROOT_STORE_NAME][STORE_NAME].data[id] : undefined,

  getProdusentNr:
    (id: string) =>
    (state: IStoreState): string | undefined => {
      if (!id) return undefined
      return getProdusentNummerFromProdusent(
        state[ROOT_STORE_NAME][STORE_NAME].data[id]?.data
      )
    },
}
